import { render, staticRenderFns } from "./PostsTable.vue?vue&type=template&id=c42b2cbe&scoped=true"
import script from "./PostsTable.vue?vue&type=script&lang=js"
export * from "./PostsTable.vue?vue&type=script&lang=js"
import style0 from "./PostsTable.vue?vue&type=style&index=0&id=c42b2cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42b2cbe",
  null
  
)

export default component.exports